import React from 'react';

const   BearsTable = () => {
    return (
        <div>
            <section id="Platform"
                className="section section-lg section-align-center section-lead section-bold section-theme-autoheight section-theme-transparent section-eyebrow-include section-theme-indent-bottom-inside-md  section-23 section-i3">
                <div className="container">
                    <div className="row">
                        <div
                            className="section-content-wrapper col-lg-8 col-lg-offset-2 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="section-content">
                                <div className="section-content-caption"><p className="section-eyebrow">Collection
                                    design</p><h2>CyberBearz Universe.</h2>
                                    <p>NFT CyberBearz Army combines artistic value, high tech, and gamification.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-option">
                    <div className="container-fluid tile-wrapper tile-wrapper-md">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="row tile-items">
                                    <div className="tile-item tile-419 tile-sm col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <div className="tile tile-bottom tile-center tile-caption-include">
                                            <div className="tile-caption">
                                                <figure className="tile-pixelart"></figure>
                                                <h3 className="h4">The pixel art trend lingers on.</h3>
                                                <p>Thanks to CryptoPunks, the pixel style will be popular for a long
                                                    time.</p></div>
                                        </div>
                                    </div>
                                    <div className="tile-item tile-420 tile-lg col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                        <div className="tile tile-top tile-left tile-caption-include">
                                            <div className="tile-caption"><h3 className="h4">Cool bears.</h3>
                                                <p>We have created nice characters and ammunition that they can use in
                                                    their adventures.</p>
                                                <p><a href="https://www.bearz.tech/outfit" className="link">Private
                                                    Barry is going to provide you will all the details </a></p>
                                                <figure className="tile-barry"></figure>
                                                <figure className="tile-bubble"></figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="tile-item tile-417 tile-full col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="tile tile-middle tile-left tile-caption-include">
                                            <div className="tile-caption"><h3 className="h4">Technology.</h3>
                                                <p>Iteration algorithm according to a four-dimensional array of 7 random
                                                    layers (more than 200 items) allows generating unique bears.</p>
                                                <blockquote><p>Each NFT token receives an identification number.</p>
                                                </blockquote>
                                                <figure className="tile-technology"></figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tile-item tile-422 tile-md col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div className="tile tile-top tile-center tile-caption-include">
                                            <div className="tile-caption"><h3 className="h4">Game potential.</h3>
                                                <p>The dropped equipment for bears determines their belonging to a
                                                    particular type of troops. This opens up huge opportunities to
                                                    organize gaming events in the community.</p>
                                                <figure className="tile-policeman"></figure>
                                                <figure className="tile-gameplay"></figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tile-item tile-421 tile-md col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div className="tile tile-bottom tile-center tile-caption-include">
                                            <div className="tile-caption">
                                                <figure className="tile-collection"></figure>
                                                <h3 className="h4">Limited edition.</h3>
                                                <p>Use them as pictures or your avatar, store them as a treasure. Only
                                                    4,096 bears will be issued. Don't miss your chance to buy them!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BearsTable;